// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@vanmeter/App/Components/Cart/LinesHeader";
import { CART_BREAKPOINT, fontConfig } from "@vanmeter/XDL/constants";
import { color, getSystemColor, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-auto-flow: column;
        grid-column-gap: 16px;

        // Wide Screens View
        ${({ showExtraCol }: any) =>
            showExtraCol
                ? "grid-template-columns: 96px minmax(220px, 1fr) minmax(0, 150px) minmax(0, 120px) minmax(0, 120px) minmax(0,150px) 16px;"
                : "grid-template-columns: 96px minmax(220px, 1fr) minmax(0, 184px) minmax(0, 137px) minmax(0, 184px) 16px;"}

        // Desktop View
        ${xScreen("lte", "lg")} {
            ${({ showExtraCol }: any) =>
                showExtraCol
                    ? "grid-template-columns: 96px minmax(220px, 1fr) minmax(0, 120px) minmax(0, 130px) minmax(0, 100px) minmax(0, 120px) 16px;"
                    : "grid-template-columns: 96px minmax(220px, 1fr) minmax(0, 154px) minmax(0, 114px) minmax(0, 154px) 16px;"}
        }

        font-size: ${fontConfig.smallSingleLine.size}px;
        line-height: ${fontConfig.smallSingleLine.lineHeight};
        font-weight: ${fontConfig.weight.bold};
        background: ${color("common.ui7")};
        color: ${color("common.white")};
        width: 100%;
        padding: 0 8px;

        ${xScreen("lte", CART_BREAKPOINT)} {
            ${({ showBorderTop }: any) => showBorderTop && `border-top: 4px solid ${getSystemColor("common.ui7")}`};
        }
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        padding: 8px 0;
        grid-column: 1 / 3;
        ${xScreen("lte", CART_BREAKPOINT)} {
            grid-column: 1 / 6;
            display: none;
        }
    `,
};

linesHeaderStyles.priceUnit = {
    css: css`
        padding: 8px 0;
        grid-column: 3 / 4;
        ${xScreen("lte", CART_BREAKPOINT)} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        padding: 8px 0;
        grid-column: 4 / 5;
        ${xScreen("lte", CART_BREAKPOINT)} {
            display: none;
        }
    `,
};
linesHeaderStyles.extraCol = {
    css: css`
        padding: 8px 0;
        grid-column: 5 / 6;
        text-align: center;
        ${xScreen("lte", CART_BREAKPOINT)} {
            display: none;
        }
    `,
};

linesHeaderStyles.total = {
    css: css`
        ${({ showExtraCol }: any) => (showExtraCol ? "grid-column: 6 / 7;" : "grid-column: 5 / 6;")}
        padding: 8px 0;
        ${xScreen("lte", CART_BREAKPOINT)} {
            display: none;
        }
    `,
};
